
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitovaranasicabs() {



    const cardData =
    {
        keyword: 'Mumbai to Varanasi Cab Service ',
        heading: 'Vedant Travels: Mumbai to Varanasi Cab Service',
        headingDescription: 'Experience a comfortable and hassle-free journey with Vedant Travels Mumbai to Varanasi cab service. Whether you’re traveling for religious purposes, business, or leisure, we provide well-maintained sedans, SUVs, and luxury vehicles to suit your needs. Our professional drivers ensure a safe and smooth ride, with flexible pickup and drop-off options. Enjoy competitive fares, 24/7 availability, and an easy online booking system to make your long-distance travel stress-free.',

        top: 'Top Places to Visit in Varanasi with Vedant Travels',

"topPlaces": [
    {
        "title": "Kashi Vishwanath Temple",
        "description": "One of the most sacred temples in India, Kashi Vishwanath Temple is dedicated to Lord Shiva. Located on the banks of the Ganges, it is a major pilgrimage site where devotees seek blessings and perform rituals."
    },
    {
        "title": "Dashashwamedh Ghat",
        "description": "The most famous ghat in Varanasi, Dashashwamedh Ghat is known for the spectacular Ganga Aarti performed every evening. Thousands gather to witness the mesmerizing ritual with lit lamps, devotional songs, and chanting."
    },
    {
        "title": "Sarnath",
        "description": "Just a short drive from Varanasi, Sarnath is a major Buddhist pilgrimage site where Lord Buddha delivered his first sermon. Visit the Dhamek Stupa, Chaukhandi Stupa, and the Sarnath Museum to explore ancient Buddhist history."
    },
    {
        "title": "Manikarnika Ghat",
        "description": "One of the oldest and most significant cremation ghats, Manikarnika Ghat symbolizes the cycle of life and death. Many believe that those cremated here attain moksha (liberation from rebirth)."
    },
    {
        "title": "Ramnagar Fort",
        "description": "Located on the eastern bank of the Ganges, Ramnagar Fort is an 18th-century fort and palace with an impressive museum showcasing antique weapons, vintage cars, and royal artifacts."
    },
    {
        "title": "Assi Ghat",
        "description": "A serene and less crowded ghat, Assi Ghat is ideal for meditation, yoga, and boat rides. It is famous for the morning Subah-e-Banaras event, which includes classical music performances and Ganga Aarti."
    },
    {
        "title": "Banaras Hindu University (BHU)",
        "description": "One of India’s most prestigious universities, BHU has a sprawling campus with beautiful architecture. The New Vishwanath Temple, located within the campus, is a must-visit for its grand structure and peaceful ambiance."
    },
    {
        "title": "Tulsi Manas Mandir",
        "description": "Dedicated to Lord Rama, Tulsi Manas Mandir is where the famous Hindu epic Ramcharitmanas was written by Tulsidas. The temple walls are inscribed with verses from the epic."
    },
    {
        "title": "Bharat Mata Temple",
        "description": "Unlike traditional temples, Bharat Mata Temple does not have idols but features a huge relief map of undivided India, symbolizing national unity."
    },
    {
        "title": "Alamgir Mosque (Beni Madhav Ka Darera)",
        "description": "A blend of Hindu and Mughal architecture, this mosque was built by Emperor Aurangzeb. It offers stunning views of the Ganges River and the city skyline."
    }
],

"services": [
    {
      "name": "Mumbai to Varanasi Cabs by Vedant Travels",
      "description": "Planning a trip from Mumbai to Varanasi? Vedant Travels offers reliable and comfortable cab services to make your journey smooth and hassle-free. Whether you’re visiting for business, leisure, or religious purposes, we provide well-maintained vehicles and professional drivers to ensure a pleasant experience."
    },
    {
      "name": "Varanasi Taxi Service",
      "description": "If you're in Varanasi and need a taxi, Vedant Travels provides excellent taxi services throughout the city. Whether you're traveling for sightseeing or need transport for your visit to religious sites, our experienced drivers and comfortable cars will ensure a safe and enjoyable trip."
    },
    {
      "name": "Mumbai to Varanasi One Way Cab",
      "description": "For a one-way journey from Mumbai to Varanasi, Vedant Travels offers affordable and convenient one-way taxi services. Our one-way cab service is perfect for travelers who don't need a return trip and want a flexible and hassle-free journey."
    },
    {
      "name": "Mumbai to Varanasi Taxi",
      "description": "Traveling by taxi from Mumbai to Varanasi has never been easier. Book your ride with Vedant Travels and enjoy a comfortable, reliable, and affordable journey. Our professional drivers are well-versed with the best routes to ensure you reach your destination on time."
    },
    {
      "name": "Mumbai to Varanasi Car Hire",
      "description": "Need a car for your trip from Mumbai to Varanasi? Vedant Travels offers a wide range of vehicles for hire, including sedans, SUVs, and more. Choose the vehicle that best suits your preferences and travel needs for a comfortable journey."
    },
    {
      "name": "Varanasi Darshan Cab",
      "description": "For those visiting Varanasi for religious purposes, Vedant Travels offers dedicated darshan cabs. Our taxis are available to take you to famous temples, ghats, and other holy sites, ensuring that your spiritual journey is smooth and convenient."
    },
    {
      "name": "Mumbai to Varanasi Taxi Fare",
      "description": "Vedant Travels offers transparent and competitive pricing for your Mumbai to Varanasi journey. We understand the importance of clear and fair pricing and ensure that there are no hidden costs. Contact us for an accurate fare quote based on your trip details."
    },
    {
      "name": "Varanasi Taxi Booking",
      "description": "Booking a taxi from Mumbai to Varanasi is simple with Vedant Travels. Whether you prefer to book online or over the phone, we offer an easy booking process to help you secure a comfortable ride. Our booking team is available to assist you anytime."
    },
    {
      "name": "Mumbai to Varanasi Innova",
      "description": "For a comfortable and spacious journey, choose an Innova for your Mumbai to Varanasi trip. Vedant Travels offers Innova cabs that are perfect for group travel or families. Enjoy the luxury of extra legroom and ample space throughout your long-distance journey."
    },
    {
      "name": "Varanasi One Way Cab from Mumbai",
      "description": "Vedant Travels offers one-way cabs from Mumbai to Varanasi, making it easy for travelers who do not need a return trip. Our one-way service ensures that you get to your destination comfortably and efficiently, without worrying about a return journey."
    }
  ],



  "tableData": [
    ["Mumbai to Varanasi Cabs", "Varanasi Taxi Service"],
    ["Mumbai to Varanasi One Way Cab", "Mumbai to Varanasi Taxi"],
    ["Mumbai to Varanasi Car Hire", "Varanasi Darshan Cab"],
    ["Mumbai to Varanasi Taxi Fare", "Varanasi Taxi Booking"],
    ["Mumbai to Varanasi Innova", "Varanasi One Way Cab from Mumbai"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we value your time. Our professional drivers ensure timely pickups and drop-offs for your Mumbai to Varanasi trip. Whether you're traveling for business or leisure, we prioritize punctuality, ensuring a smooth and stress-free journey."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Our fleet of well-maintained vehicles offers comfort throughout your long-distance journey. With spacious interiors, air conditioning, and comfortable seating, you can relax and enjoy the scenic ride from Mumbai to Varanasi."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and trained to handle long-distance travel. With expert knowledge of the best routes and safe driving practices, they ensure a smooth and efficient ride, making your journey from Mumbai to Varanasi pleasant and safe."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive pricing with no hidden charges. Our pricing structure is transparent, ensuring you know the cost upfront. You’ll get the best value for your money, without any unexpected costs."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure a secure journey for you."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning departure or a late-night return, Vedant Travels is available round the clock. Our customer service team is always ready to assist you with bookings or any queries, making your journey hassle-free."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Varanasi cab is quick and easy. You can book online through our website or mobile app, or you can contact our customer service team for assistance with your booking."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer flexible travel packages tailored to your needs. Whether you’re traveling for business, a family trip, or sightseeing, we customize the journey to suit your schedule and preferences."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Varanasi cab with Vedant Travels?',
            answer: 'You can easily book your cab online through our website or mobile app. Alternatively, you can contact our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mumbai to Varanasi trip?',
            answer: 'We offer a wide range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are designed for comfort and safety, ensuring a pleasant and smooth journey.',
        },
        {
            id: 3,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced and trained for long-distance travel. They are familiar with the best routes and safety procedures, ensuring a smooth and timely ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Varanasi cab rental?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments via our app, making payment simple and convenient.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab for Mumbai to Varanasi?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during the booking process, and we’ll ensure a hassle-free return journey.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours during the Mumbai to Varanasi trip?',
            answer: 'Any additional charges for waiting or detours will be communicated to you upfront. We believe in complete transparency, so there are no hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Varanasi?',
            answer: 'Yes, we offer sightseeing tours in Varanasi. Visit popular attractions such as Kashi Vishwanath Temple, Dashashwamedh Ghat, Sarnath, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Varanasi cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or specialized luggage, please let us know at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Varanasi?',
            answer: 'Yes, we provide corporate travel services for business trips to Varanasi. Whether it’s for meetings, conferences, or corporate events, we ensure your travel is comfortable and timely.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Varanasi travel?',
            answer: 'Vedant Travels offers reliable, comfortable, and affordable cab services for your Mumbai to Varanasi trip. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure your journey is safe, smooth, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anil Gupta",
            title: "Customer",
            quote: "I traveled from Mumbai to Varanasi with Vedant Travels, and the experience was exceptional. The driver was professional, the car was clean and comfortable, and I reached my destination on time. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Shweta Patil",
            title: "Customer",
            quote: "Our family trip from Mumbai to Varanasi with Vedant Travels was wonderful. The vehicle was spacious, and the driver was friendly and knowledgeable. We had a pleasant experience and will definitely choose their services again.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   
      

const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Varanasi Cabs | Vedant Travels",
  "description": "Book your Mumbai to Varanasi cab with Vedant Travels for a comfortable and affordable journey. We offer reliable taxi services for one-way trips, Varanasi darshan, and round trips. Choose from premium vehicles like Innova Crysta, Ertiga, and Swift Dzire.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "950"
  }
};


    return (
        <div>
           <Helmet>
  <title>Mumbai to Varanasi Cabs | Vedant Travels | Contact: +91 8767459909</title>
  <meta name="description" content="Book your Mumbai to Varanasi cab with Vedant Travels. We offer reliable and affordable taxi services for one-way trips, Varanasi darshan, and round trips. Choose from premium vehicles like Innova Crysta, Ertiga, and Swift Dzire." />
  <meta name="keywords" content="mumbai to varanasi cabs, varanasi taxi service, mumbai to varanasi one way cab, mumbai to varanasi taxi, mumbai to varanasi car hire, varanasi darshan cab, mumbai to varanasi taxi fare, varanasi taxi booking, mumbai to varanasi innova, varanasi one way cab from mumbai" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vedanttravels.in/mumbai-to-varanasi-cabs" />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/97.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitovaranasicabs;